import React from 'react';
import { useTeamColors } from 'hooks';

import { StyledButton } from './style.js';

const Button = ({
  title,
  onClick,
  disabled = false,
  withIcon = false,
  icon,
  before,
  $bgColor,
  pulsate = false,
}) => {
  const { mainColor } = useTeamColors();

  return (
    <StyledButton
      $bgColor={$bgColor || mainColor}
      $pulsate={pulsate}
      disabled={disabled}
      onClick={onClick}
    >
      {withIcon && before ? icon : null}
      {title}
      {withIcon && !before ? icon : null}
    </StyledButton>
  );
};

export default Button;
